import { useCallback } from "react";
import {
  getInspectionResults,
  getInspectionResultsFullHierarchy,
} from "../../../api/InspectionResults";
import { getInspectionDefFullHierarchy } from "../../../api/InspectionDefinitions";
import { useWorkOrderStore } from "../../../store/wo-order";

export default function useGetInspection() {
  const setWoInspectionData = useWorkOrderStore(
    (state) => state.setWoInspectionData
  );

  const getInspectionDefHierarchy = useCallback(
    async (inspectionId: number | string, woNumber: string) => {
      const defResponse = await getInspectionDefFullHierarchy({
        //explicitly convert to string -- iOS issue
        inspectionId: String(inspectionId),
      });
      setWoInspectionData(woNumber, {
        isCompleted: false,
        inspectionDef: defResponse.data,
      });
      return defResponse;
    },
    [setWoInspectionData]
  );

  const getInspection = useCallback(
    async (woNumber: string) => {
      const workOrder = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      const inspectionId = workOrder?.InspectionId;
      let hasError = false;
      let data: any = undefined;

      const woBase = woNumber.includes('-') ? woNumber.split('-')[0] : woNumber;
      let response = await getInspectionResults(`wo_base='${woBase}'`);
      hasError = response.isError;
      let status = response.status;
      data = response.data;
      if (!response.isError) {
        if (response.data?.length > 0) {
          const matchingResult = response.data.find((result: any) => {
            let apiWorkOrder = result.WoBase || "";

            if (result.WoTask && result.WoTask.trim() !== "") {
              apiWorkOrder += `-${result.WoTask}`;
            }

            if (result.WoSubtask && result.WoSubtask.trim() !== "") {
              apiWorkOrder += `-${result.WoSubtask}`;
            }

            return apiWorkOrder === woNumber;
          });
          if (matchingResult) {
            const { ResultId, InspectionId } = matchingResult;
            const resultResponse = await getInspectionResultsFullHierarchy({
              //explicitly convert to string -- iOS issue
              inspectionId: String(InspectionId),
              resultId: String(ResultId),
            });
            hasError = resultResponse.isError;
            status = resultResponse.status;
            data = resultResponse.data;
            const isCompleted = resultResponse.status === 200;
            setWoInspectionData(woNumber, {
              isCompleted,
              inspectionResults: resultResponse.data,
              inspectionId: InspectionId,
            });
          } else {
            // No exact match found, treat as incomplete
            if (typeof inspectionId === "number") {
              const defResponse = await getInspectionDefHierarchy(
                inspectionId,
                woNumber
              );
              hasError = defResponse.isError;
              status = defResponse.status;
              data = defResponse.data;
            }
          }
        } else if (typeof inspectionId === "number") {
          const defResponse = await getInspectionDefHierarchy(
            inspectionId,
            woNumber
          );

          hasError = defResponse.isError;
          status = defResponse.status;
          data = defResponse.data;
        }
      }
      return { hasError, data, status };
    },
    [getInspectionDefHierarchy, setWoInspectionData]
  );

  return { getInspection, getInspectionDefHierarchy };
}
